function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.171 12.8h2.5a.483.483 0 01.5.523v9.409a.483.483 0 01-.5.523h-2.5",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.322 10.584L8.4 12.977a1.4 1.4 0 01-1.045.523H6.171m0 7.034c2.144 1.625 4.1 2.716 5.363 2.716h6.273c.76 0 1.238-.054 1.568-1.045a63.517 63.517 0 001.046-7.66c0-.522-.523-1.045-1.568-1.045h-5.932m-2.367-1.295L9.006 1.373a.546.546 0 01.54-.623H17.1",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.839 13.5l-.916-9.159a.5.5 0 01.5-.553h6.9a.5.5 0 01.5.577l-1.38 9.2",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7 8.621a.375.375 0 11-.379.379.375.375 0 01.375-.375",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgCashPaymentBills(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgCashPaymentBills;